<section>
  <app-pdf-top-header [filter]="filter"></app-pdf-top-header>
  <div class="pdf-container">
    <ng-container *ngFor="let item of statisticsCard; let i = index">
      <div class="pdf-item" [ngClass]="i<=1 && 'half'">
        <app-pdf-statistics-card
          [cardHeaderCount]="item?.statistics"
          [cardHeaderLabel]="item?.label"
          [percentage]="item?.statisticsPercentage"
          [totalFemales]="item?.female"
          [totalMales]="item?.male"
          [total]="item?.total"
        ></app-pdf-statistics-card>
      </div>
    </ng-container>
  </div>
  <div class="cards">
    <ng-container *ngFor="let card of statisticsData">
      <app-statistics-card
        [cardHeaderLabel]="card?.cardHeaderLabel"
        [percentage]="card?.percentage"
        [statisticsLabel]="card?.statisticsLabel"
        [statisticsPercent]="card?.statisticsPercent"
      ></app-statistics-card>
    </ng-container>
  </div>
</section>
